import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CreateFlashcardsChatComponent } from "./create-flashcards-chat.component";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  declarations: [
    CreateFlashcardsChatComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ControlsModule,
    SharedModule
  ],
  exports: [
    CreateFlashcardsChatComponent
  ]
})
export class CreateFlashcardsChatModule { }